import { addRecipeToFavorites } from '../RecipeDB/recipeService'; // <- solo lo que se usa
import { getAuth } from "firebase/auth";
import { systemPrompt } from './chatSystemPrompt'; // <- antes venía de chatHandlers
import { API } from '../config/api';

// Nueva función segura: llama al backend (Cloud Function)
export async function getOpenAIResponse(messages) {
  const user = getAuth().currentUser;
  if (!user) throw new Error("User not authenticated");

  const idToken = await user.getIdToken();
  const svcUrl = API.chatProxy;

  const normalize = (m) => {
    let role = m.role ?? (m.sender === 'assistant' ? 'assistant' : 'user');
    let raw = m.content ?? m.text ?? "";
    if (typeof raw === "object" && raw !== null) {
      // intentar extraer campos comunes
      if (typeof raw.content === "string") raw = raw.content;
      else if (typeof raw.message === "string") raw = raw.message;
      else if (typeof raw.delta === "string") raw = raw.delta;
      else {
        console.warn("Normalizando content objeto a string:", raw);
        raw = JSON.stringify(raw);
      }
    }
    return { role, content: String(raw ?? "") };
  };

  const openaiMessages = [];
  const hasSystem = Array.isArray(messages) && messages.some(m => m?.role === 'system' || m?.sender === 'system');
  if (!hasSystem) openaiMessages.push(systemPrompt);

  for (const m of messages || []) {
    if (!m) continue;
    openaiMessages.push(normalize(m));
  }

  const response = await fetch(svcUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${idToken}`,
    },
    body: JSON.stringify({ messages: openaiMessages }),
  });

  // Verifica CORS / status y parsea la respuesta
  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(`Chat error ${response.status}: ${text || response.statusText}`);
  }

  const data = await response.json();
  return data.output;
}

// Función para guardar una receta en favoritos
export const handleSaveRecipe = async (userId, recipeText) => {
  try {
    // Extraer los datos de la receta del texto
    const nombreMatch = recipeText.match(/\*\*NOMBRE:\*\* (.*)/);
    const ingredientesMatch = recipeText.match(/\*\*INGREDIENTES:\*\*([\s\S]*?)\*\*INSTRUCCIONES:\*\*/);
    const instruccionesMatch = recipeText.match(/\*\*INSTRUCCIONES:\*\*([\s\S]*?)\*\*DIFICULTAD:\*\*/);
    const dificultadMatch = recipeText.match(/\*\*DIFICULTAD:\*\* (.*)/);
    const tiempoMatch = recipeText.match(/\*\*TIEMPO DE ELABORACIÓN:\*\* (.*)/);

    if (nombreMatch && ingredientesMatch && instruccionesMatch && dificultadMatch && tiempoMatch) {
      const recipe = {
            nombre: nombreMatch[1].trim(),
            ingredientes: ingredientesMatch[1].trim().split('\n').map(ing => ({
              nombre: ing.replace('-', '').trim(),
              cantidad: '0',
              unidad: 'unidad'
            })),
            instrucciones: instruccionesMatch[1].trim().split('\n').map(inst => inst.trim()),
            dificultad: dificultadMatch[1].trim(),
            tiempoEstimado: tiempoMatch ? parseInt(tiempoMatch[1], 10) || 0 : 0,
            fuente: 'CookyChat',
            imagen: '',
            urlOrigen: '',
            valoraciones: []
      };

      await addRecipeToFavorites(userId, recipe);
    } else {
      console.error('Error al extraer los datos de la receta del mensaje del asistente.');
    }
  } catch (error) {
    console.error('Error al guardar la receta en favoritos:', error);
  }
};